/* ============================================================
   PR Bundle Subscription Buy Box  (block: pr_bundle_subs_buy_box)

   Owns the ReCharge dynamic-bundle add-to-cart for bundle PDPs.
   Everything visual is rendered server-side by
   snippets/pr-bundle-subs-buy-box.liquid — this file only holds
   pick state and performs the cart call:

     validateBundleSelection -> getBundleId -> /cart/add.js

   The ReCharge bundle id is minted at runtime, which is why this
   cannot be pure Liquid. Prices, selling plans, product titles,
   images and availability all come from Liquid, not from fetches.
============================================================ */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__pbxReady) return;
    root.__pbxReady = true;

    var cfg = {};
    try { cfg = JSON.parse(root.getAttribute('data-pbx-config') || '{}'); } catch (e) { cfg = {}; }

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-pbx-step]'));
    var tabs  = Array.prototype.slice.call(root.querySelectorAll('[data-pbx-tab]'));
    var atc   = root.querySelector('[data-pbx-atc]');
    var note  = root.querySelector('[data-pbx-note]');

    /* Mobile bundle sheet (A/B). Declared here because the sticky observer below
       needs the trigger as an alternate anchor. Every one of these is inert until
       Intelligems puts .pbx--sheet on the root. */
    var sheet     = root.querySelector('[data-pbx-sheet]');
    var opens     = Array.prototype.slice.call(root.querySelectorAll('[data-pbx-open]'));
    var trigger   = root.querySelector('.pbx__trigger');
    var backdrop  = root.querySelector('[data-pbx-backdrop]');
    var nextBtn   = root.querySelector('[data-pbx-next]');
    var summary   = root.querySelector('[data-pbx-summary]');
    var tilesBox  = root.querySelector('[data-pbx-summary-tiles]');
    var sheetMQ   = window.matchMedia('(max-width: 599px)');
    var sheetOpen = false;

    var picks = {};        // { pid: qty }
    var active = 0;
    var busy = false;

    /* ---------- helpers ---------- */
    function required(i) { return parseInt(steps[i].getAttribute('data-required'), 10) || 0; }

    function itemsIn(i) {
      return Array.prototype.slice.call(steps[i].querySelectorAll('[data-pbx-item]'));
    }

    function countIn(i) {
      return itemsIn(i).reduce(function (n, el) {
        return n + (picks[el.getAttribute('data-pid')] || 0);
      }, 0);
    }

    function stepFull(i) { return countIn(i) >= required(i); }
    function allFull() { return steps.every(function (_, i) { return stepFull(i); }); }
    function pad(n) { return (n < 10 ? '0' : '') + n; }

    /* ---------- rendering ---------- */
    function paint() {
      steps.forEach(function (stepEl, i) {
        var have = countIn(i);
        var need = required(i);
        var full = have >= need;

        stepEl.hidden = (i !== active);

        var counter = stepEl.querySelector('[data-pbx-count]');
        if (counter) counter.textContent = '(' + have + '/' + need + ')';

        itemsIn(i).forEach(function (el) {
          var pid = el.getAttribute('data-pid');
          var qty = picks[pid] || 0;
          var addBtn = el.querySelector('[data-pbx-add]');
          var qtyBox = el.querySelector('[data-pbx-qty]');
          var qtyVal = el.querySelector('[data-pbx-qtyval]');
          var inc    = el.querySelector('[data-pbx-inc]');

          el.classList.toggle('is-picked', qty > 0);
          if (addBtn) addBtn.hidden = qty > 0;
          if (qtyBox) qtyBox.hidden = qty === 0;
          if (qtyVal) qtyVal.textContent = pad(qty);
          // can't exceed the step quota, and sold-out items never add
          if (addBtn) addBtn.disabled = full || el.getAttribute('data-available') === 'false';
          if (inc) inc.disabled = full;
        });
      });

      tabs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === active);
        t.classList.toggle('is-done', stepFull(i));
        t.setAttribute('aria-selected', i === active ? 'true' : 'false');
      });

      if (atc) {
        atc.disabled = !allFull() || busy;
        atc.classList.toggle('is-ready', allFull() && !busy);
      }

      // swap CTA labels while the ReCharge round-trip is in flight
      ctaButtons.forEach(function (b) {
        if (!b) return;
        if (busy) {
          if (!b.hasAttribute('data-label')) b.setAttribute('data-label', b.textContent);
          b.textContent = cfg.busyLabel || 'ADDING…';
        } else if (b.hasAttribute('data-label')) {
          b.textContent = b.getAttribute('data-label');
          b.removeAttribute('data-label');
        }
      });

      paintSticky();
      paintSheet();
    }

    /* ---------- sticky bar ---------- */
    var sticky      = root.querySelector('[data-pbx-sticky]');
    var stickyCount = root.querySelector('[data-pbx-sticky-count]');
    var stickyPrice = root.querySelector('[data-pbx-sticky-price]');
    var stickySave  = root.querySelector('[data-pbx-sticky-save]');
    var stickyOne   = root.querySelector('[data-pbx-atc-one]');
    var stickySub   = root.querySelector('[data-pbx-atc-sub]');
    var chips       = Array.prototype.slice.call(root.querySelectorAll('[data-pbx-chip]'));
    var ctaButtons  = [atc, root.querySelector('[data-pbx-atc-one]'), root.querySelector('[data-pbx-atc-sub]')];

    function paintSticky() {
      if (!sticky) return;

      // slots: one chip per required ITEM (single-step bundles) - fills as items are picked
      // steps: one chip per STEP (multi-step bundles) - fills when a whole step is done
      var total = cfg.slotTotal || steps.length;
      var done;
      if (cfg.stickyMode === 'slots') {
        var picked = steps.reduce(function (n, _, i) { return n + countIn(i); }, 0);
        done = Math.min(picked, total);
      } else {
        done = steps.reduce(function (n, _, i) { return n + (stepFull(i) ? 1 : 0); }, 0);
      }
      if (stickyCount) {
        stickyCount.textContent = (cfg.selectedWord || 'Selected') + ' ' + done + '/' + total;
      }

      chips.forEach(function (chip, i) {
        chip.classList.toggle('is-done', cfg.stickyMode === 'slots' ? i < done : stepFull(i));
      });

      var sel = root.querySelector('.pr-sub__freq-opt.is-selected') || root.querySelector('.pr-sub__freq-opt');
      var isSub = currentMode() === 'sub' && sel;
      var price = isSub ? sel.getAttribute('data-price') : cfg.oneMoney;
      var save  = isSub ? sel.getAttribute('data-sticky-save') : cfg.oneSave;

      if (stickyPrice) stickyPrice.textContent = price || '';
      if (stickySave) {
        var show = save && !/^\D*0([.,]0+)?\D*$/.test(save);
        stickySave.textContent = show ? ((cfg.savePrefix || 'Save') + ' ' + save) : '';
      }

      var ready = allFull() && !busy;
      if (stickyOne) stickyOne.disabled = !ready;
      if (stickySub) stickySub.disabled = !ready;
    }

    if (stickyOne) stickyOne.addEventListener('click', function () { addToCart('one'); });
    if (stickySub) stickySub.addEventListener('click', function () { addToCart('sub'); });

    /* Visibility: hidden on load; shown once the inline buy box has scrolled
       out of view; hidden again as soon as the footer comes into view. */
    if (sticky && 'IntersectionObserver' in window) {
      var boxOut = false;
      var boxPast = false;
      var footerIn = false;
      var stickyMQ = window.matchMedia('(max-width: 749px)');
      if (stickyMQ.addEventListener) stickyMQ.addEventListener('change', function () { sync(); });

      /* In the sheet variant the card is position:fixed and never scrolls out, so
         it is useless as an anchor. The trigger/summary sits where the card used to,
         so we watch both and read whichever one is in flow right now. The control
         path is unchanged: sheetOn() is false, so it reads cardOut exactly as before. */
      var triggerIn = false;
      var summaryIn = false;
      var triggerPast = false;
      var summaryPast = false;

      /* On mobile the buy box usually starts BELOW the fold, so "not intersecting" is
         already true at load and the bar would flash up before the user scrolls. Match
         the PDP sticky (evaluateStickyNow in product-revamp): on small screens require
         the box to have scrolled ABOVE the viewport, not merely be out of view.
         A display:none element reports a zero rect, whose bottom is 0 and would read as
         "past", so height must be non-zero for it to count. */
      function pastTop(entry) {
        var r = entry.boundingClientRect;
        return r.height > 0 && r.bottom <= 0;
      }

      function sync() {
        var out;
        if (sheetOn()) {
          // sheet mode is mobile-only, so always use the past-the-top rule
          out = triggerPast || summaryPast;
        } else if (stickyMQ.matches) {
          out = boxPast;
        } else {
          out = boxOut;
        }
        sticky.classList.toggle('is-visible', out && !footerIn);
      }

      var anchor = root.querySelector('.pbx__card') || root;
      new IntersectionObserver(function (entries) {
        boxOut = !entries[0].isIntersecting;
        boxPast = pastTop(entries[0]);
        sync();
      }, { threshold: 0 }).observe(anchor);

      [trigger, summary].forEach(function (el) {
        if (!el) return;
        new IntersectionObserver(function (entries) {
          if (el === trigger) { triggerIn = entries[0].isIntersecting; triggerPast = pastTop(entries[0]); }
          else { summaryIn = entries[0].isIntersecting; summaryPast = pastTop(entries[0]); }
          sync();
        }, { threshold: 0 }).observe(el);
      });

      if (sheetMQ.addEventListener) sheetMQ.addEventListener('change', sync);
      else if (sheetMQ.addListener) sheetMQ.addListener(sync);

      var footer = document.querySelector(cfg.footerSelector || 'footer, .footer, [data-footer]');
      if (footer) {
        new IntersectionObserver(function (entries) {
          footerIn = entries[0].isIntersecting;
          sync();
        }, { threshold: 0 }).observe(footer);
      }
    }

    /* ---------- mobile bundle sheet (A/B) ----------
       Figma 14214:2549 / 2945 / 3118 / 3535.

       Below 600px the variant lifts the step picker out of the page and into a
       bottom sheet, with a trigger button and a picked-products summary taking
       its place. Nothing here runs unless Intelligems has added .pbx--sheet:

         document.querySelectorAll('[data-pbx]')
           .forEach(function (el) { el.classList.add('pbx--sheet'); });

       Pick state, the ReCharge call and the page's own ADD TO CART are untouched —
       SAVE BUNDLE only closes the sheet. */

    function sheetOn() {
      return !!sheet && root.classList.contains('pbx--sheet') && sheetMQ.matches;
    }

    /* Arm the slide transitions only once the browser has painted the closed sheet.
       Intelligems adds .pbx--sheet after the card has already laid out in flow, and
       a transform transition that is live at that moment animates the jump from
       in-flow card to off-screen sheet — the picker slides down the screen on load.
       Two frames: the first lets the closed state paint, the second turns motion on. */
    function armSheetAnim() {
      if (!sheet) return;
      if (!root.classList.contains('pbx--sheet')) return;
      if (root.classList.contains('is-sheet-ready')) return;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { root.classList.add('is-sheet-ready'); });
      });
    }

    armSheetAnim();
    if (window.MutationObserver) {
      // the class usually lands after this script has run, so watch for it
      new MutationObserver(armSheetAnim)
        .observe(root, { attributes: true, attributeFilter: ['class'] });
    }

    function pickedTotal() {
      return steps.reduce(function (n, _, i) { return n + countIn(i); }, 0);
    }

    function buildTiles() {
      var n = 0;
      if (!tilesBox) return n;
      var frag = document.createDocumentFragment();

      steps.forEach(function (_, i) {
        itemsIn(i).forEach(function (el) {
          var qty = picks[el.getAttribute('data-pid')] || 0;
          if (!qty) return;

          if (n > 0) {
            var plus = document.createElement('span');
            plus.className = 'pbx__summary-plus';
            plus.setAttribute('aria-hidden', 'true');
            plus.textContent = '+';
            frag.appendChild(plus);
          }

          var tile = document.createElement('div');
          tile.className = 'pbx__summary-tile';

          var src = el.querySelector('.pbx__item-img img');
          if (src) {
            var img = document.createElement('img');
            img.src = src.currentSrc || src.src;
            img.alt = '';
            img.width = 52;
            img.height = 52;
            img.loading = 'lazy';
            tile.appendChild(img);
          }

          var name = document.createElement('span');
          name.className = 'pbx__summary-name';
          name.textContent = el.getAttribute('data-title') || '';
          tile.appendChild(name);

          // Pack line first, then the count when there is more than one — e.g.
          // "12 Servings ×2". Showing only the count hid the servings info on exactly
          // the item the shopper bought most of.
          var sub = el.querySelector('.pbx__item-sub');
          var packLine = sub ? sub.textContent.trim() : '';
          var line = packLine;
          if (qty > 1) {
            line = packLine ? (packLine + ' ×' + qty) : ('×' + qty);
          }
          if (line) {
            var qtyEl = document.createElement('span');
            qtyEl.className = 'pbx__summary-qty';
            qtyEl.textContent = line;
            tile.appendChild(qtyEl);
          }

          frag.appendChild(tile);
          n++;
        });
      });

      tilesBox.textContent = '';
      tilesBox.appendChild(frag);
      // the row never wraps; anything past the edge is reached by scrolling it
      tilesBox.scrollLeft = 0;
      return n;
    }

    function paintSheet() {
      if (!sheet) return;

      var picked = pickedTotal();
      if (trigger) trigger.hidden = picked > 0;
      if (summary) summary.hidden = picked === 0;
      if (picked > 0) buildTiles();

      if (nextBtn) {
        var last = active >= steps.length - 1;
        nextBtn.textContent = last
          ? (cfg.sheetSaveLabel || 'SAVE BUNDLE')
          : ((cfg.sheetNextLabel || 'STEP') + ' ' + (active + 2));
      }
    }

    var prevHtmlOverflow = '';
    var prevBodyOverflow = '';
    var lastFocus = null;

    function openSheet() {
      if (!sheetOn() || sheetOpen) return;
      sheetOpen = true;
      lastFocus = document.activeElement;

      // dialog semantics exist only while the sheet is really a dialog
      sheet.setAttribute('role', 'dialog');
      sheet.setAttribute('aria-modal', 'true');
      sheet.setAttribute('aria-label', sheet.getAttribute('data-pbx-sheet-label') || '');

      prevHtmlOverflow = document.documentElement.style.overflow;
      prevBodyOverflow = document.body.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';

      root.classList.add('is-sheet-open');
      opens.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });

      var first = sheet.querySelector('button:not([disabled])');
      if (first) first.focus();
      paint();
    }

    function closeSheet() {
      if (!sheetOpen) return;
      sheetOpen = false;

      sheet.removeAttribute('role');
      sheet.removeAttribute('aria-modal');
      sheet.removeAttribute('aria-label');

      document.documentElement.style.overflow = prevHtmlOverflow;
      document.body.style.overflow = prevBodyOverflow;

      root.classList.remove('is-sheet-open');
      opens.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });

      if (lastFocus && lastFocus.focus) lastFocus.focus();
      paint();
    }

    opens.forEach(function (b) { b.addEventListener('click', openSheet); });
    if (backdrop) backdrop.addEventListener('click', closeSheet);

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (active < steps.length - 1) {
          active += 1;
          paint();
          if (sheet) sheet.scrollTop = 0;
          return;
        }
        closeSheet();
      });
    }

    document.addEventListener('keydown', function (ev) {
      if (sheetOpen && (ev.key === 'Escape' || ev.key === 'Esc')) closeSheet();
    });

    // leaving mobile with the sheet open would strand the scroll lock
    function onSheetMQ() { if (!sheetMQ.matches) closeSheet(); }
    if (sheetMQ.addEventListener) sheetMQ.addEventListener('change', onSheetMQ);
    else if (sheetMQ.addListener) sheetMQ.addListener(onSheetMQ);

    /* Swipe the grab handle down to dismiss. The design has no close button, so
       without this the only ways out are the backdrop and the footer button. */
    var grab = root.querySelector('.pbx__grab');
    if (grab) {
      var dragFrom = null;
      grab.addEventListener('touchstart', function (ev) {
        dragFrom = ev.touches[0].clientY;
      }, { passive: true });
      grab.addEventListener('touchmove', function (ev) {
        if (dragFrom === null) return;
        var dy = ev.touches[0].clientY - dragFrom;
        if (dy > 60) { dragFrom = null; closeSheet(); }
      }, { passive: true });
      grab.addEventListener('touchend', function () { dragFrom = null; }, { passive: true });
    }

    function say(msg, isErr) {
      if (!note) return;
      note.textContent = msg || '';
      note.hidden = !msg;
      note.classList.toggle('is-err', !!isErr);
    }

    /* ---------- auto-advance ---------- */
    function advanceIfDone() {
      if (!stepFull(active)) return;
      for (var i = active + 1; i < steps.length; i++) {
        if (!stepFull(i)) { active = i; return; }
      }
    }

    /* ---------- events ---------- */
    root.addEventListener('click', function (ev) {
      var tab = ev.target.closest('[data-pbx-tab]');
      if (tab && root.contains(tab)) {
        active = tabs.indexOf(tab);
        paint();
        return;
      }

      var item = ev.target.closest('[data-pbx-item]');
      if (!item || !root.contains(item)) return;

      var pid = item.getAttribute('data-pid');
      var stepEl = item.closest('[data-pbx-step]');
      var i = steps.indexOf(stepEl);
      var need = required(i);

      if (ev.target.closest('[data-pbx-add]') || ev.target.closest('[data-pbx-inc]')) {
        if (item.getAttribute('data-available') === 'false') return;
        if (countIn(i) >= need) return;
        picks[pid] = (picks[pid] || 0) + 1;
        say('');
        advanceIfDone();
        paint();
        return;
      }

      if (ev.target.closest('[data-pbx-dec]')) {
        picks[pid] = Math.max(0, (picks[pid] || 0) - 1);
        if (!picks[pid]) delete picks[pid];
        say('');
        paint();
      }
    });

    /* ---------- subscribe / one-time toggle ---------- */
    var subBox = root.querySelector('[data-pr-sub]');
    if (subBox) {
      subBox.addEventListener('click', function (ev) {
        var opt = ev.target.closest('.pr-sub__opt');
        if (!opt || ev.target.closest('[data-sub-freq-box]')) return;
        Array.prototype.forEach.call(subBox.querySelectorAll('.pr-sub__opt'), function (o) {
          o.classList.toggle('is-active', o === opt);
        });
        paint();
      });

      // frequency dropdown
      var freqToggle = subBox.querySelector('[data-sub-freq-toggle]');
      var freqList = subBox.querySelector('[data-sub-freq-list]');
      if (freqToggle && freqList) {
        freqToggle.addEventListener('click', function (e) {
          e.stopPropagation();
          var open = !freqList.hidden;
          freqList.hidden = open;
          freqToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        });
        // Paint the subscribe row from a plan option. Also runs at boot so the
        // price/save/frequency are correct before the shopper opens the list.
        function applyPlan(opt) {
          if (!opt) return;
          Array.prototype.forEach.call(freqList.querySelectorAll('.pr-sub__freq-opt'), function (o) {
            o.classList.remove('is-selected');
          });
          opt.classList.add('is-selected');
          var lbl = subBox.querySelector('[data-sub-freq]');
          if (lbl) lbl.textContent = opt.getAttribute('data-freq') || '';
          var pr = subBox.querySelector('[data-sub-price]');
          if (pr) pr.textContent = opt.getAttribute('data-price') || '';
          var sv = subBox.querySelector('[data-sub-save]');
          if (sv) sv.textContent = opt.getAttribute('data-save-label') || '';
          // keep the native <select> in sync so the value posts correctly
          var native = root.querySelector('[data-sub-freq-select]');
          if (native) native.value = opt.getAttribute('data-value') || native.value;
          paintSticky();
        }

        freqList.addEventListener('click', function (e) {
          var opt = e.target.closest('.pr-sub__freq-opt');
          if (!opt) return;
          applyPlan(opt);
          freqList.hidden = true;
          freqToggle.setAttribute('aria-expanded', 'false');
        });

        applyPlan(freqList.querySelector('.pr-sub__freq-opt.is-selected')
               || freqList.querySelector('.pr-sub__freq-opt'));
        document.addEventListener('click', function () { freqList.hidden = true; });
      }
    }

    function currentMode() {
      var a = root.querySelector('.pr-sub__opt.is-active');
      return a && a.getAttribute('data-type') === 'otp' ? 'one' : 'sub';
    }

    function currentPlanId() {
      var sel = root.querySelector('.pr-sub__freq-opt.is-selected') || root.querySelector('.pr-sub__freq-opt');
      return sel ? sel.getAttribute('data-value') : null;
    }

    /* ---------- add to cart ---------- */

    /* ============================================================
       COLLECTION RESOLUTION

       ReCharge validates the submission against ITS OWN bundle settings, so
       ReCharge is the authority on collection ids - not the Shopify handle.
       Deriving the id from the handle is what produced
         "The collections (X) are no longer valid for the bundle variant (Y)"
       on the earlier US build.

       Priority: manual override  >  ReCharge  >  Shopify collection id
    ============================================================ */
    var TAG = '[pbx]';

    function isCollectionKey(lk) {
      return /collection(_external)?_id$/.test(lk) || lk === 'collectionid' || lk === 'collection';
    }

    function distinctCids(node) {
      var seen = {}, out = [];
      (function walk(n) {
        if (!n || typeof n !== 'object') return;
        for (var k in n) {
          var v = n[k];
          if (v && typeof v === 'object') { walk(v); continue; }
          if (isCollectionKey(k.toLowerCase()) && v != null && v !== '') {
            var sv = String(v);
            if (!seen[sv]) { seen[sv] = 1; out.push(sv); }
          }
        }
      })(node);
      return out;
    }

    // Pull every {collectionId, min, max} rule out of a bundle variant payload.
    // Written against meaning rather than exact key names - ReCharge has shifted
    // this shape between SDK versions.
    function findRanges(node) {
      function num(v) { var n = Number(v); return isNaN(n) ? null : n; }
      var found = [];
      (function walk(n, inherited) {
        if (!n || typeof n !== 'object') return;
        if (Object.prototype.toString.call(n) === '[object Array]') {
          for (var i = 0; i < n.length; i++) walk(n[i], inherited);
          return;
        }
        var cid = inherited, min = null, max = null, k, lk, v;
        for (k in n) {
          v = n[k];
          if (v && typeof v === 'object') continue;
          lk = k.toLowerCase();
          if (isCollectionKey(lk)) { if (v != null && v !== '') cid = String(v); }
          else if (lk === 'min' || lk === 'min_quantity') min = num(v);
          else if (lk === 'max' || lk === 'max_quantity') max = num(v);
          else if (lk === 'quantity' || lk === 'required_quantity') {
            if (min == null) min = num(v);
            if (max == null) max = num(v);
          }
        }
        if (!cid) {
          var below = distinctCids(n);
          if (below.length === 1) cid = below[0];
        }
        if (cid && min != null) found.push({ collectionId: cid, min: min, max: (max == null ? min : max) });
        for (var k2 in n) if (n[k2] && typeof n[k2] === 'object') walk(n[k2], cid);
      })(node, null);

      var seen = {}, out = [];
      for (var i = 0; i < found.length; i++) {
        if (!seen[found[i].collectionId]) { seen[found[i].collectionId] = 1; out.push(found[i]); }
      }
      return out;
    }

    function rechargeRanges() {
      var fn = sdkFn('getCDNBundleSettings');
      if (!fn) {
        console.warn(TAG, 'getCDNBundleSettings unavailable on this SDK build - falling back to Shopify collection ids.');
        return Promise.resolve(null);
      }
      return Promise.resolve(fn(String(cfg.parentProductId))).then(function (settings) {
        var variants = (settings && settings.variants) || [];
        var bv = variants.filter(function (v) {
              return String(v.external_variant_id || v.externalVariantId || v.id) === String(cfg.parentVariantId);
            })[0]
            || variants.filter(function (v) {
              return String(v.id) === String(settings && settings.default_bundle_variant_id);
            })[0]
            || variants[0];
        if (!bv) {
          console.error(TAG, 'No ReCharge bundle variant matched', cfg.parentVariantId,
                        '- check the bundle is configured for this product in ReCharge.');
          return null;
        }
        return findRanges(bv);
      }).catch(function (e) {
        console.warn(TAG, 'getCDNBundleSettings failed:', e);
        return null;
      });
    }

    // Map ReCharge rules onto the configured steps. Quantity is the strongest
    // signal (drinks needs 2, sachets needs 3); declaration order breaks ties.
    function assignCollections(ranges) {
      var rows = [], used = {};

      if (ranges && ranges.length) {
        steps.forEach(function (el, i) {
          var m = ranges.filter(function (r) { return !used[r.collectionId] && r.min === required(i); })[0];
          if (m) {
            used[m.collectionId] = 1;
            el.setAttribute('data-rc-collection-id', m.collectionId);
            el.__rcMin = m.min; el.__rcMax = m.max;
          }
        });
        var left = ranges.filter(function (r) { return !used[r.collectionId]; });
        steps.forEach(function (el) {
          if (el.getAttribute('data-rc-collection-id') || !left.length) return;
          var r = left.shift();
          el.setAttribute('data-rc-collection-id', r.collectionId);
          el.__rcMin = r.min; el.__rcMax = r.max;
        });

        if (ranges.length !== steps.length) {
          console.warn(TAG, 'ReCharge defines ' + ranges.length + ' collection rule(s) but this block has ' +
                       steps.length + ' step(s). Check the step setup against the ReCharge bundle.');
        }
      }

      steps.forEach(function (el, i) {
        var manual  = (el.getAttribute('data-manual-collection-id') || '').trim();
        var fromRc  = el.getAttribute('data-rc-collection-id') || '';
        var shopify = el.getAttribute('data-collection-id') || '';
        var chosen  = manual || fromRc || shopify;
        var source  = manual ? 'manual override' : (fromRc ? 'ReCharge' : 'Shopify handle (FALLBACK)');
        el.setAttribute('data-resolved-collection-id', chosen);

        if (!chosen) {
          console.error(TAG, 'Step ' + (i + 1) + ' has no collection id - add to cart WILL fail. ' +
                        'Set the ReCharge collection ID on this step.');
        }
        if (fromRc && shopify && fromRc !== shopify && !manual) {
          console.warn(TAG, 'Step ' + (i + 1) + ' collection MISMATCH. ReCharge=' + fromRc +
                       ' Shopify=' + shopify + '. Using ReCharge - it is what ReCharge validates against.');
        }
        if (el.__rcMin != null && el.__rcMin !== required(i)) {
          console.warn(TAG, 'Step ' + (i + 1) + ' quantity MISMATCH. Block requires ' + required(i) +
                       ', ReCharge reports min ' + el.__rcMin + ' / max ' + el.__rcMax +
                       '. Keeping the block value - ReCharge is authoritative only for the collection id.');
        }
        rows.push({ step: i + 1, required: required(i),
                    rechargeMin: (el.__rcMin == null ? '-' : el.__rcMin),
                    collectionId: chosen, source: source });
      });

      if (console.table) { console.table(rows); } else { console.log(TAG, rows); }
      return rows;
    }

    var collectionsReady = null;
    function sdkFn(name) {
      if (typeof recharge === 'undefined') return null;
      if (recharge.bundle && typeof recharge.bundle[name] === 'function') return recharge.bundle[name];
      if (recharge.cdn && typeof recharge.cdn[name] === 'function') return recharge.cdn[name];
      if (typeof recharge[name] === 'function') return recharge[name];
      return null;
    }


    /* Refresh the cart drawer and open it, using the theme's own hooks.
       <cart-items>.getCart() re-renders the drawer and its build() dispatches
       'theme:product:added', which is what <cart-drawer> listens to in order to
       open. The theme's normal ATC path can't be reused here because it rebuilds
       from a <form>, and a ReCharge bundle is posted as JSON with _rb_id. */
    function revealCart() {
      try {
        var cartEl = document.querySelector('cart-items');
        if (cartEl && typeof cartEl.getCart === 'function') {
          cartEl.getCart();
          return;
        }
        // drawer script present but element not upgraded yet - ask it to open
        if (document.querySelector('cart-drawer')) {
          document.dispatchEvent(new CustomEvent('theme:product:added', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('theme:cart-drawer:open', { bubbles: true }));
          return;
        }
      } catch (e) { /* fall through to the cart page */ }
      // last resort: no cart drawer on this page - go to the cart page
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      window.location = root + 'cart';
    }
    function addToCart(mode) {
      if (!allFull() || busy) return;
      mode = (mode === 'sub' || mode === 'one') ? mode : currentMode();
      busy = true; say(''); paint();

      var selections = [];
      var selectionSteps = [];
      var contents = [];
      steps.forEach(function (stepEl, i) {
        itemsIn(i).forEach(function (el) {
          var pid = el.getAttribute('data-pid');
          var qty = picks[pid];
          if (!qty) return;
          selections.push({
            collectionId: stepEl.getAttribute('data-resolved-collection-id') || stepEl.getAttribute('data-collection-id') || '',
            externalProductId: pid,
            externalVariantId: el.getAttribute('data-vid'),
            quantity: qty
          });
          selectionSteps.push(stepEl);
          contents.push(qty + 'x ' + (el.getAttribute('data-title') || ''));
        });
      });

      var bundle = {
        externalProductId: String(cfg.parentProductId || ''),
        externalVariantId: String(cfg.parentVariantId || ''),
        selections: selections
      };

      var getId = sdkFn('getBundleId');
      var validate = sdkFn('validateBundleSelection');
      if (!getId) {
        busy = false;
        say(cfg.errSdk || 'Bundle service unavailable. Please refresh and try again.', true);
        paint();
        return;
      }

      Promise.resolve(collectionsReady)
        .then(function () {
          // re-read ids in case resolution finished after the click
          selections.forEach(function (sel, n) {
            var el = selectionSteps[n];
            if (el) sel.collectionId = el.getAttribute('data-resolved-collection-id') || sel.collectionId;
          });
          return validate ? validate(bundle) : null;
        })
        .then(function () { return getId(bundle); })
        .then(function (bid) {
          var rbId = (bid && bid.id) ? bid.id : bid;
          var props = { _rb_id: String(rbId) };
          if (contents.length && cfg.contentsProperty) {
            props[cfg.contentsProperty] = contents.join('\n') + '\n';
          }
          var body = {
            items: [{
              id: Number(cfg.parentVariantId),
              quantity: 1,
              properties: props
            }]
          };
          if (mode === 'sub') {
            var plan = currentPlanId();
            if (plan) body.items[0].selling_plan = Number(plan);
          }
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(body)
          }).then(function (r) {
            if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Cart error'); });
            return r.json();
          });
        })
        .then(function () {
          busy = false;
          // clear the picker so the next bundle starts from scratch
          picks = {};
          active = 0;
          say('');
          paint();
          revealCart();
        })
        .catch(function (err) {
          busy = false;
          say((err && err.message) || cfg.errCart || 'Could not add the bundle. Please try again.', true);
          paint();
        });
    }

    if (atc) atc.addEventListener('click', function () { addToCart(); });

    // ReCharge SDK init (token is a public storefront token)
    if (typeof recharge !== 'undefined' && cfg.storefrontToken) {
      try {
        var opts = { storefrontAccessToken: cfg.storefrontToken, appName: 'pmd-pr-bundle-subs', appVersion: '1.0.0' };
        if (cfg.storeIdentifier) opts.storeIdentifier = cfg.storeIdentifier;
        recharge.init(opts);
      } catch (e) { /* SDK already initialised elsewhere */ }
      collectionsReady = rechargeRanges().then(assignCollections);
    } else {
      assignCollections(null);   // no SDK on the page - log what we would send
    }

    paint();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pbx]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Shopify theme editor re-renders blocks
  document.addEventListener('shopify:section:load', boot);
})();
